if (!customElements.get('cart-finance')) {
  customElements.define(
    'cart-finance',
    class CartFinance extends window.BAO.CustomElement {
      constructor () {
        super()

        this.cssClasses = {
          exclude: 'crt-Summary_FinanceExcludeMessage-show',
          success: 'crt-Summary_FinanceSuccessMessage-show',
        }
      }

      toggleFinanceMessages () {
        if (document.querySelector('[data-finance-excluded]')) {
          this.els.excludedMessage.element.classList.add(
            this.cssClasses.exclude,
          )
          this.els.successMessage.element.classList.remove(
            this.cssClasses.success,
          )
        } else {
          this.els.successMessage.element.classList.add(this.cssClasses.success)
          this.els.excludedMessage.element.classList.remove(
            this.cssClasses.exclude,
          )
        }
      }

      setupListeners () {
        super.setupListeners()

        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.PUSH_CART.AFTER_REMOVE,
          () => {
            this.toggleFinanceMessages()
          },
        )
      }
    },
  )
}
